import { render, staticRenderFns } from "./CopyrightAssignmentTransferMessagesEscalated.vue?vue&type=template&id=5e958f21&scoped=true&"
import script from "./CopyrightAssignmentTransferMessagesEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferMessagesEscalated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e958f21",
  null
  
)

export default component.exports